/**
 * Returns the flag image URL for a given ISO 3166-1 alpha-2 country code.
 * Returns null if the flag file is not found (fallback to emoji).
 * @param {string} countryCode - ISO 3166-1 alpha-2 country code (e.g. 'GB', 'US')
 * @returns {string|null} Flag image URL or null if not found
 */
let flagsContext = null;

try {
  flagsContext = require.context(
    '../../@pano-project/assets/icons/flags',
    false,
    /\.svg$/
  );
} catch (error) {
  flagsContext = null;
}

const flagKeys = flagsContext ? flagsContext.keys() : [];

const FLAG_ALIASES = {
  sh: 'gb', // Saint Helena, Ascension and Tristan da Cunha -> United Kingdom
};

export const getCountryFlagImage = (countryCode) => {
  if (
    !countryCode ||
    typeof countryCode !== 'string' ||
    countryCode.length !== 2
  ) {
    return null;
  }
  const lower = countryCode.toLowerCase();
  const code = FLAG_ALIASES[lower] || lower;
  const path = `./${code.toUpperCase()}.svg`;
  if (flagsContext && flagKeys.includes(path)) {
    const result = flagsContext(path);
    const url = typeof result === 'string' ? result : result?.default;
    return typeof url === 'string' ? url : null;
  }
  return null;
};
